import React, { Fragment, useCallback, useMemo, useState } from 'react'
import styled from 'styled-components'
import Typography from '@mui/material/Typography'
import { IconButton } from '@mui/material'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import CloseIcon from '@mui/icons-material/Close';
import AssetCard from './AssetCard';

const Container = styled.div`
  position: absolute;
  bottom: 0;
  width: 100%;
  max-width: 600px;
  right: 50px;
  background: #fff;
  z-index: 1;
  border-radius: 10px 10px 0 0;
`

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 10px;
  background: #119d83;
  border-radius: 10px 10px 0 0;
`

const HeaderButtons = styled.div`
  display: flex;
`

const Body = styled.div`
  display: flex;
  flex-direction: column;
  max-height: 500px;
  overflow-y: auto;
  transition: max-height .5s;
  ${p => p.isCollapse && 'max-height: 0;'}
`

const labelStyle = { color: '#fff' }

const LoadingAssets = ({ assets, tags, types, onClose, onSave, onConfigOpen, onTypeChange, onTagsChange }) => {
  const [isCollapse, setIsCollapse] = useState(false)

  const toggleCollapse = useCallback(() => setIsCollapse(!isCollapse), [isCollapse]) 

  const totalFiles = useMemo(() => assets?.filter(a => a.percent)?.length ?? 0, [assets])
  const uploadedFiles = useMemo(() => assets?.filter(a => a.percent === 100)?.length ?? 0, [assets])

  return (
    <Container>
      <Header>
        {uploadedFiles < totalFiles
          ? <Typography sx={labelStyle}>Uploading Files... ({uploadedFiles}/{totalFiles}) </Typography>
          : <Typography sx={labelStyle}>Files Uploaded </Typography>
        }
        <HeaderButtons>
          <IconButton aria-label="toggle" onClick={toggleCollapse}>
            {isCollapse
              ? <KeyboardArrowUpIcon /> 
              : <KeyboardArrowDownIcon />
            }
          </IconButton>
          {uploadedFiles === totalFiles && (
            <IconButton aria-label="close" onClick={onClose}>
              <CloseIcon />
            </IconButton>
          )}
        </HeaderButtons>
      </Header>
      <Body isCollapse={isCollapse}>
        {assets.map(asset => (
          <Fragment key={asset.asset_id}>
            {asset.percent && <AssetCard
              asset={asset}
              tags={tags}
              types={types}
              onSave={onSave}
              onConfigOpen={onConfigOpen}
              onTypeChange={onTypeChange}
              onTagsChange={onTagsChange}
            />}
          </Fragment>
        ))}
      </Body>
    </Container>
  )
}

export default LoadingAssets
